import { CountryRegionData as CRD } from 'react-country-region-selector';

// CountryRegionData 라이브러리 옵션 데이터 뽑기용
const getData = () => (CRD && (CRD.default || CRD)) || [];

export const buildCountryOptions = (valueType = 'short') => {
  const data = getData();
  return data.map(([name, code]) => ({
    label: name,
    value: valueType === 'short' ? code : name,
    code,
  }));
};

export const buildRegionOptions = (
  countryValue,
  { countryValueType = 'short', valueType = 'short' } = {}
) => {
  if (!countryValue) return [];
  const data = getData();
  const entry = data.find(([n, c]) =>
    countryValueType === 'short' ? c === countryValue : n === countryValue
  );

  const regionsStr = entry?.[2] || '';
  if (!regionsStr) return [];

  const parts = String(regionsStr).split('|');
  return parts.map((p) => {
    const [rName, rCode] = String(p).split('~');
    const value = valueType === 'short' && rCode ? rCode : rName;
    return { label: rName, value, code: rCode || null };
  });
};

// 코드/이름 -> 표시 이름으로 정규화 (페이로드 변환용)
export const countryValueToName = (countryValue) => {
  if (!countryValue) return '';
  const data = getData();
  const match = data.find(([name, code]) => code === countryValue || name === countryValue);
  return match ? match[0] : countryValue;
};

export const regionValueToName = (countryValue, regionValue) => {
  if (!countryValue || !regionValue) return '';
  const data = getData();
  const entry = data.find(([name, code]) => code === countryValue || name === countryValue);
  if (!entry) return regionValue;
  const regionsStr = entry[2] || '';
  if (!regionsStr) return regionValue;
  const parts = String(regionsStr).split('|');
  for (const p of parts) {
    const [rName, rCode] = String(p).split('~');
    if (regionValue === rCode || regionValue === rName) return rName;
  }
  return regionValue;
};
